export default (value) => {
  if (value === null || value === undefined || value === '') {
    return true;
  }
  const passEmail = new RegExp(
    "^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$"
  ).test(value);
  const passNumber = new RegExp('^[0-9]*$').test(value);
  return passEmail || passNumber;
};
